import {
  TILBY_CREATE_URL,
  TILBY_INIT_WEBHOOK_URL,
} from 'shared/utils/Constants';

import {
  destroy,
  get,
  post,
} from 'shared/services/ApiService';

class TilbyService {
  async createPayment(accountId, params) {
    return post(TILBY_CREATE_URL(accountId), params);
  }

  async initWebhook(accountId) {
    return get(TILBY_INIT_WEBHOOK_URL(accountId));
  }

  // TODO: JLC to check
  async deleteWebhook(params) {
    return get(TILBY_INIT_WEBHOOK_URL, params);
  }
}

export default new TilbyService();
